var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcExpandRow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  fill: "none",
  viewBox: "0 0 12 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  strokeWidth: 2,
  d: "m1.526 1.5 4.737 5L11 1.5"
})));
export { SvgIcExpandRow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEuNTI2MzcgMS41TDYuMjYzMjEgNi41TDExLjAwMDEgMS41IiBzdHJva2U9IiMzQzk3QUEiIHN0cm9rZS13aWR0aD0iMiIgLz4KPC9zdmc+";